import { PimAssociation, PimAttribute, PimClass } from "@dataspecer/core/pim/model";
const GENERALIZATION_PREFIX = "https://dataspecer.com/semantic-models/generalization";
function getGeneralizationIri(fromIri, toIri) {
    const url = new URLSearchParams({ fromIri, toIri });
    return GENERALIZATION_PREFIX + url.toString();
}
function createGeneralization(fromIri, toIri) {
    return {
        id: getGeneralizationIri(fromIri, toIri),
        iri: null,
        type: ["generalization"],
        child: fromIri,
        parent: toIri,
    };
}
export function transformPimClass(cls) {
    const result = {};
    const semanticClass = {
        id: cls.iri,
        iri: cls.pimInterpretation ?? null,
        name: cls.pimHumanLabel ?? {},
        description: cls.pimHumanDescription ?? {},
        nameProperty: cls.pimHumanLabelProperty ?? null,
        descriptionProperty: cls.pimHumanDescriptionProperty ?? null,
        type: ["class"],
    };
    result[cls.iri] = semanticClass;
    if (cls.pimIsCodelist) {
        semanticClass.isCodelist = true;
        semanticClass.codelistUrl = cls.pimCodelistUrl;
    }
    cls.pimExtends
        .map((to) => createGeneralization(cls.iri, to))
        .forEach((generalization) => (result[generalization.id] = generalization));
    return result;
}
export function transformCoreResources(resources, relationshipMapping = {}) {
    let result = {};
    // Transform classes
    for (const resource of Object.values(resources)) {
        if (PimClass.is(resource)) {
            // // Hotfix remove empty classes
            // if (!resource.pimHumanLabel || !Object.keys(resource.pimHumanLabel).length) {
            //     continue;
            // }
            // Hotfix remove owl:Thing
            if (resource.iri === "http://www.w3.org/2002/07/owl#Thing") {
                continue;
            }
            // Merge transform pim class into result
            result = { ...result, ...transformPimClass(resource) };
        }
        if (PimAssociation.is(resource)) {
            const left = resources[resource.pimEnd[0]];
            const right = resources[resource.pimEnd[1]];
            relationshipMapping[left.iri] = [resource.iri, true];
            relationshipMapping[right.iri] = [resource.iri, false];
            const association = {
                id: resource.iri,
                iri: null,
                type: ["relationship"],
                name: resource.pimHumanLabel ?? {},
                description: resource.pimHumanDescription ?? {},
                nameProperty: resource.pimHumanLabelProperty ?? null,
                descriptionProperty: resource.pimHumanDescriptionProperty ?? null,
                ends: [
                    {
                        cardinality: ((left.pimCardinalityMin ?? 0) === 0 && left.pimCardinalityMax === null) ? undefined : [left.pimCardinalityMin ?? 0, left.pimCardinalityMax],
                        name: left.pimHumanLabel ?? {},
                        description: left.pimHumanDescription ?? {},
                        nameProperty: left.pimHumanLabelProperty ?? null,
                        descriptionProperty: left.pimHumanDescriptionProperty ?? null,
                        concept: left.pimPart,
                        iri: null,
                    },
                    {
                        cardinality: [right.pimCardinalityMin ?? 0, right.pimCardinalityMax],
                        name: right.pimHumanLabel ?? resource.pimHumanLabel ?? {},
                        description: right.pimHumanDescription ?? resource.pimHumanDescription ?? {},
                        nameProperty: right.pimHumanLabelProperty ?? resource.pimHumanLabelProperty ?? null,
                        descriptionProperty: right.pimHumanDescriptionProperty ?? resource.pimHumanDescriptionProperty ?? null,
                        concept: right.pimPart,
                        iri: resource.pimInterpretation ?? null,
                    },
                ],
            };
            result[association.id] = association;
            // @ts-ignore
            const ext = resource["pimExtends"] ?? [];
            ext.map((to) => createGeneralization(association.id, to))
                .forEach((generalization) => (result[generalization.id] = generalization));
        }
        if (PimAttribute.is(resource)) {
            relationshipMapping[resource.iri] = [resource.iri, false];
            const attribute = {
                id: resource.iri,
                iri: null,
                type: ["relationship"],
                name: {},
                description: {},
                nameProperty: null,
                descriptionProperty: null,
                ends: [
                    {
                        cardinality: [0, null],
                        name: {},
                        description: {},
                        nameProperty: null,
                        descriptionProperty: null,
                        concept: resource.pimOwnerClass,
                        iri: null,
                    },
                    {
                        cardinality: [resource.pimCardinalityMin ?? 0, resource.pimCardinalityMax],
                        name: resource.pimHumanLabel ?? {},
                        description: resource.pimHumanDescription ?? {},
                        nameProperty: resource.pimHumanLabelProperty ?? null,
                        descriptionProperty: resource.pimHumanDescriptionProperty ?? null,
                        concept: resource.pimDatatype ?? "http://www.w3.org/2000/01/rdf-schema#Literal",
                        iri: resource.pimInterpretation ?? null,
                    },
                ],
            };
            result[attribute.id] = attribute;
            // @ts-ignore
            const ext = resource["pimExtends"] ?? [];
            ext.map((to) => createGeneralization(attribute.id, to))
                .forEach((generalization) => (result[generalization.id] = generalization));
        }
    }
    return result;
}
//# sourceMappingURL=transform-core-resources.js.map